import React, { useState } from 'react'
import { Box, Grid } from '@material-ui/core'

import { Container, Page, RoundedBorder } from 'components'
import { RipdForm, Header, ReportVersionTable } from './components'

import constants from 'constants/index'

import useStyles from './styles'

const ImpactReport = () => {
  const classes = useStyles()
  const [triggerValidation, setTriggerValidation] = useState(() => {})
  const [currentReportVersion, setCurrentReportVersion] = useState()

  return (
    <Page
      className={classes.root}
      title={'Registro das Atividades de Tratamento (RoPA)'}
    >
      <Box position="relative">
        <RoundedBorder />
      </Box>
      <Container maxWidth={false} spacingXl={15} spacingLg={10} spacingMd={5}>
        <Box py={5}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Header
                type="ropa"
                reportTour="ropa"
                {...(!!currentReportVersion?.id && {
                  buttonAction: async () => {
                    const valid = await triggerValidation()
                    if (!valid) return
                  },
                  shouldSubmit: true,
                })}
              />
            </Grid>
            <Grid item xs={12}>
              <RipdForm ropa setTriggerValidation={setTriggerValidation} />
            </Grid>
            <Grid item xs={12}>
              <ReportVersionTable
                currentReportVersion={currentReportVersion}
                setCurrentReportVersion={setCurrentReportVersion}
                kind={constants.reportVersions.KIND.ROPA}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Page>
  )
}

export default ImpactReport
